<template>
  <div class="my_shop">
    <van-row>
      <van-notice-bar :text="$t('column.Conditions_for_opening_small_shops')"/>
      <van-cell :title="$t('column.Complete_certification')" size="large" :label="auth_status"/>
      <van-cell :title="$t('column.Deposit')" :value="open_my_shop_margin_num" size="large" :label="margin_status_str"/>
      <van-button @click="clickOpenShop" type="primary" round block>{{ $t('btn.apply_for_shop')}}</van-button>
    </van-row>

    <van-overlay :show="showOverlay" @click="show = false">
      <div class="shop_auth_block" @click.stop>
        <van-col span="24">
          <van-col span="24" class="my_shop_auth_top_view">
            <img src="./../assets/img/bg_shop_info_auth.png" class="my_shop_auth_top"/>
          </van-col>
        </van-col>
        <van-row>
          <van-col span="24">{{ $t('column.application_is_under_review')}}</van-col>
        </van-row>
      </div>
    </van-overlay>
  </div>
</template>

<script>
    import axios from "axios";
    import Toast from "vant/lib/toast"
    import {Dialog} from 'vant';

    export default {
        name: "my_shop",
        data() {
            return {
                showOverlay: false,
                open_my_shop_margin_num: 0,
                auth_status: '',
                is_authentication: 0,
                satisfy: 0,
                margin_status: 0,
                margin_status_str: '',
            }
        },
        created: function () {
            document.title = this.$t('title.my_shop')
            this.initData();
        },
        methods: {
            clickOpenShop: function () {
                if (this.is_authentication != 2) {
                    Toast(this.$t('Tips.Not_meeting_opening_conditions'));
                    return
                }

                if (this.satisfy !== 1 && this.margin_status !== 1) {
                    Dialog.confirm({
                        title: this.$t('Tips.Suggestive_language'),
                        message: this.$t('Tips.confirm_payment') + this.open_my_shop_margin_num + this.$t('Tips.bond'),
                        confirmButtonText: this.$t('btn.confirm'),
                        cancelButtonText: this.$t('btn.cancel'),
                    })
                        .then(() => {
                            this.requestMargin();
                        })
                        .catch(() => {

                        });
                    return;
                }
                const token = this.$route.query.token
                this.$router.push({path: '/create_shop', query: {token: token}});
            },
            //请求缴纳保证金
            requestMargin: function () {
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=myshop&act=pay_gold", {
                    params: {
                        token: token,
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.data.status === 0) {
                        Toast(res.data.error);
                        return;
                    }
                    Toast(this.$t('Tips.successful_payment'));
                    this.satisfy = 1;
                    this.margin_status = 1;
                    this.margin_status_str = this.$t('Tips.Paid');
                });
            },
            initData: function () {
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=myshop&act=my_shop_index", {
                    params: {
                        token: token,
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.data.status === 0) {
                        Toast(res.data.error);
                        return;
                    }
                    this.is_authentication = res.data.is_authentication;
                    if (res.data.is_authentication == 2) {
                        this.auth_status = this.$t('Tips.Certified')
                    } else {
                        this.auth_status = this.$t('Tips.Not_certified')
                    }
                    this.satisfy = res.data.satisfy;
                    this.margin_status = res.data.margin_status;
                    if (this.margin_status === 1) {
                        this.margin_status_str = this.$t('Tips.Paid');
                    } else {
                        this.margin_status_str = this.$t('Tips.Unpaid');
                    }

                    this.open_my_shop_margin_num = res.data.open_my_shop_margin_num + res.data.diamonds_name;
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/my_shop.vue